import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toNumber, getItemFromArray } from "../../components/Common";
import * as APP from "../../redux_store/appState";
import { ClearScratch } from "../layout/PaperDesigner";
import { updateLayout2D } from "../../redux_store/appStateHelper";
import { updateAreaSpecification } from "../../redux_store/jobState";

export const GetItems = (parameters) => {
    if (window.svg && window.paper) {
        return window.paper.project.getItems(parameters);
    }
    return null;
};

const SetChildrenGrey = (item) => {
    if (!item?.children) return;
    item.children.forEach(function (item) {
        if (window.last_pop_item === item) {
            return;
        }
        if (item.fillColor) item.fillColor = "#dddddd";
        if (item.strokeColor) item.strokeColor = "#bbbbbb";
        item.pickable = false;
        if (item.children) {
            SetChildrenGrey(item);
        }
    });
};

export function FormatSVGForMovingDownlights(pop_item) {
    let items = GetItems();
    if (items?.[0]?.children) {
        SetChildrenGrey(items?.[0]);
    }

    if (!pop_item) {
        pop_item = window.last_pop_item;
    } else {
        window.last_pop_item = pop_item;
    }
    let text_items = GetItems({ class: window.paper.TextItem });
    text_items.forEach(function (item) {
        if (!item.is_downlight) {
            item.sendToBack();
        }
    });

    GetItems({ is_downlight: true }).forEach(function (dl) {
        dl.bringToFront();
        dl.fillColor = "#448844";
        dl.strokeColor = "#448844";
        dl.strokeWidth = 4;
        dl.pickable = true;
        text_items.forEach(function (item) {
            if (item.ref === dl.ref && item.dl_index === dl.dl_index && item.areaIndex == dl.areaIndex) {
                item.parent = dl;
                item.fillColor = "#000000";
                item.strokeColor = "#000000";
                item.bringToFront();
                item.pickable = false;
            }
        });
    });
}

export default function SpecMoveDownlight(props) {
    const dispatch = useDispatch();
    const app = useSelector((state) => state.app);
    const { pop_item } = props;

    const SELECT_POINT = app.designer.designer2D[APP.SELECT_POINT];
    const [loaded, setLoaded] = React.useState(false);
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const areaIndex = pop_item ? pop_item.areaIndex : 0;

    function UpdateMovedDownlights() {
        const existing_downlights = AreaSpecifications[areaIndex]?.Downlights;
        let new_downlights = { ...existing_downlights };
        GetItems({ is_downlight: true, moved: true }).forEach(function (item) {
            let x_offset = item.position.x - item.orig_point.x;
            let y_offset = item.position.y - item.orig_point.y;
            let adjustment = { x: 0, y: 0, z: 0 };
            if (new_downlights[item.ref]["Adjustment_" + item.dl_index]) {
                adjustment = new_downlights[item.ref]["Adjustment_" + item.dl_index];
            }
            adjustment.x += Math.round(x_offset);
            adjustment.y -= Math.round(y_offset);
            adjustment.x = Math.round(adjustment.x);
            adjustment.y = Math.round(adjustment.y);
            new_downlights[item.ref]["Adjustment_" + item.dl_index] = adjustment;
        });
        dispatch(updateAreaSpecification(pop_item.areaIndex, "Downlights", null, new_downlights));
    }

    React.useEffect(() => {
        if (!loaded) return;
        if (SELECT_POINT === false) {
            UpdateMovedDownlights();
            dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, false));
            onClose();
        }
    }, [SELECT_POINT]);

    React.useEffect(() => {
        if (!loaded && props.open) {
            moveDownlight();
            setLoaded(true);
        }
    }, [props?.open]);

    const moveDownlight = () => {
        ClearScratch();

        if (window.svg) {
            window.last_pop_item = props.pop_item;
            FormatSVGForMovingDownlights(props.pop_item);
        }

        // dispatch(APP.update2DDesigner(APP.SELECT_POINT_NOTE, <>*Right click or press 'ESC' to finish.</>));
        dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, true));
        dispatch(APP.update2DDesigner(APP.SELECTED_POINT, false));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, "MoveItems"));
    };

    const onClose = () => {
        ClearScratch();
        setLoaded(false);

        dispatch(updateLayout2D());
        if (props.onClose) {
            props.onClose();
            return;
        }
    };

    return (
        <div
            style={{
                maxWidth: "450px",
                textAlign: "left",
                top: "100px",
                padding: "10px",
                background: "#d7751bab",
                position: "absolute",
                right: "12px",
                zIndex: "5",
                color: "white",
            }}
        >
            <>
                Drag downlight to move. <br />
                *Right click or press 'ESC' to finish.
            </>
        </div>
    );
}
